import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Link as Link1 } from 'react-scroll';
import {FiPhoneCall, FiMail,FiMapPin} from '../assets/icons/vander'

export default function GetInTuchFour(){
    const [responseMessage, setResponseMessage] = useState("");
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        comments: "",
        termsAccepted: false,
    });
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prevData) => ({
        ...prevData,
        [name]: type === "checkbox" ? checked : value,
        }));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        try {
            const { protocol, hostname, port, pathname } = window.location;
            let url = `${protocol}//${hostname}${port ? `:${port}` : ''}/contact1.php`;
            const response = await fetch(url, {
                method: "POST",
                body: formData
            });
            const data = await response.json();
            setResponseMessage(data.message || "Form submitted successfully!");
            setFormData({name:"", email:"", subject:"", comments:"", termsAccepted:false});
        } catch (error) {
            setResponseMessage("Error submitting the form.");
        }
    };
    return(
        <section className="section" id="trabajaConNosotros">
        <div className="container">
            <div className="row">
                <div className="col-lg-4 col-md-6 col-12">
                    <div className="section-title mb-4">
                        <h4 className="title mb-4">Contactanos</h4>
                        {/* <p className="text-muted para-desc mb-0">Start working with Fronter that can provide everything you need to generate awareness, drive traffic, connect.</p> */}
                    </div>

                    <div className="row">
                        <div className="col-12 mt-4">
                            <div className="d-flex features feature-primary">
                                <div className="feature-icon rounded  text-center">
                                    <FiPhoneCall className="d-block h3 mb-0 icon"/>
                                </div>
                                <div className="flex-1 ms-4">
                                    <h6 className="mb-1">Teléfono</h6>
                                    <Link to="tel:623255264" className="link">623 255 264</Link>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-12 mt-4">
                            <div className="d-flex features feature-primary">
                                <div className="feature-icon rounded text-center">
                                    <FiMail className="d-block mb-0 icon"/>
                                </div>
                                <div className="flex-1 ms-4">
                                    <h6 className="mb-1">Correo</h6>
                                    <Link to="mailto:info@pilatesrizzo.com" className="link">info@pilatesrizzo.com</Link>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-12 mt-4">
                            <div className="d-flex features feature-primary">
                                <div className="feature-icon rounded  text-center">
                                    <FiMapPin className="d-block h3 mb-0 icon"/>
                                </div>
                                <div className="flex-1 ms-4">
                                    <h6 className="mb-1">Ubicación</h6>
                                    <Link1 to="dondeEstamos" className="lightbox text-primary">Ver en Google Maps</Link1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-lg-8 col-md-6 col-12 mt-4 pt-2 mt-sm-0 pt-sm-0">
                    <div className="p-4 rounded shadow">
                        <form id="contact-form" onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label className="form-label">Su nombre <span className="text-danger">*</span></label>
                                        <input name="name" id="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            type="text" className="form-control" required/>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label className="form-label">Su correo <span className="text-danger">*</span></label>
                                        <input name="email" id="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            type="email" className="form-control" required/>
                                    </div> 
                                </div>

                                <div className="col-12">
                                    <div className="mb-3">
                                        <label className="form-label">Asunto <span className="text-danger">*</span></label>
                                        <input type="text" name="subject" id="subject"
                                            value={formData.subject}
                                            onChange={handleChange}
                                            className="form-control" required/>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="mb-3">
                                        <label className="form-label">Comentarios <span className="text-danger">*</span></label>
                                        <textarea name="comments" id="comments"
                                            value={formData.comments}
                                            onChange={handleChange}
                                            rows="4" className="form-control" required></textarea>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <input type="checkbox" id="privay-policy" name="termsAccepted" required
                                    checked={formData.termsAccepted}
                                    onChange={handleChange} />
                                <label for="privay-policy">He leído y acepto la <a href="/politica-privacidad" target="_blank" className="lightbox text-primary">Política de privacidad</a></label>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <p className="text-primary text-center">{responseMessage}</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="d-grid">
                                        <button type="submit" id="submit" name="send" className="btn btn-primary">Enviar mensaje</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    )
}